import type { IconProps } from "./types";

export function ChevronRight({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.263604 0.263592C0.615078 -0.0878565 1.18558 -0.0878718 1.53704 0.263592L7.53704 6.26359C7.88839 6.61507 7.88845 7.18559 7.53704 7.53703L1.53704 13.537C1.18561 13.8885 0.615085 13.8884 0.263604 13.537C-0.0878678 13.1856 -0.0878678 12.6151 0.263604 12.2636L5.62689 6.90031L0.263604 1.53703C-0.087868 1.18556 -0.087868 0.615064 0.263604 0.263592Z"
        fill={currentColor}
        transform="translate(8.1 5.1)"
      />
    </svg>
  );
}
